import React from 'react';
import { Tooltip, Grid, Chip, makeStyles, Typography } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  container: {
    margin: 0,
    padding: theme.spacing(1, 1, 0, 1)
  },
  label: {
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.secondary
  },
  message: {
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.secondary
  },
  status: {
    maxWidth: '100%',
    color: theme.palette.dtm.text,
    backgroundColor: theme.palette.dtm.main
  },
  draftLabel: {
    fontStyle: 'italic'
  }
}));

export const DraftHiringRequisitionInfoContentDetail = () => {
  const classes = useStyles();

  const { formatMessage } = useIntl();

  const hiringDraftStatus = formatMessage({ id: 'hiringBadge.draft' });

  return (
    <>
      <Grid container spacing={2} className={classes.container}>
        <Grid item xs={6}>
          <Typography variant="body2" className={classes.label} noWrap>
            <FormattedMessage id="requisitionInformation.status" />
          </Typography>
          <Tooltip title={hiringDraftStatus} placement="bottom-start">
            <Chip
              size="medium"
              data-qe-id="hiring-draft-status-chip"
              label={hiringDraftStatus}
              className={classNames(classes.status, classes.draftLabel)}
            />
          </Tooltip>
        </Grid>
      </Grid>

      <Grid container spacing={2} className={classes.container}>
        <Grid item xs={12}>
          <Typography variant="body2" className={classes.message}>
            <FormattedMessage id="draftHiringRequisitionInformation.info" />
          </Typography>
          <Typography variant="body2" className={classes.message}>
            <FormattedMessage id="draftHiringRequisitionInformation.additionalInfo" />
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

DraftHiringRequisitionInfoContentDetail.propTypes = {};

export default DraftHiringRequisitionInfoContentDetail;
